import * as React from 'react';
import { Link } from '@tanstack/react-router';

interface AccountMenuOptionsProps {
  isLoggedIn: boolean;
}

const ACCOUNT_MENU_LOGGED_IN = [
  {
    label: 'Account Home',
    path: '/account/home',
  },
  {
    label: 'Saved Quotes',
    path: '/account/saved-quotes',
  },
  {
    label: 'My Orders',
    path: '/account/orders',
  },
  {
    label: 'My Details',
    path: '/account/details',
  },
  {
    label: 'Logout',
    path: '/logout',
  }
];

const ACCOUNT_MENU_LOGGED_OUT = [
  {
    label: 'Sign In',
    path: '/my-account',
  },
];

export default function AccountMenuOptions(props: AccountMenuOptionsProps) {
  const menu = props.isLoggedIn ? ACCOUNT_MENU_LOGGED_IN : ACCOUNT_MENU_LOGGED_OUT;
  return(
    <ul className="pt-4">
      {menu.map((item) => (
        <li className="p-1" key={item.label}>
          <Link to={item.path} className="text-xl">{item.label}</Link>
        </li>
      ))}
    </ul>
  )
}
